import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { I1FilenetServices } from 'src/app/acl-data/i1-filenet-services.service';
import { concatMap, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { IAclID } from 'src/app/acl-data/aclID.interface';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { FolderDataSource } from 'src/app/acl-data/folder/folder.datasource';
import { DataSource } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AccessTypePopupComponent } from '../access-type-popup/access-type-popup.component';
import { of } from 'rxjs';


@Component({
  selector: 'app-manage-user-access',
  templateUrl: './manage-user-access.component.html',
  styleUrls: ['./manage-user-access.component.scss']
})


export class ManageUserAccessComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  objectStoreRef;
  rootFolder$ = this.route.paramMap.pipe(
    withLatestFrom(this.route.data),
    switchMap(([_, x]) =>{
      this.objectStoreRef = x.parentMenu.data.parentMenu.path
      console.log(this.objectStoreRef)
    return this.folderService.getRootFolder(x.parentMenu.data.parentMenu.path)
    }
     )
  );
  

    
  showLoadingPopup = false;
  subs = new SubSink();

  libraryIDs;

  displayedColumns: string[] = [
    'User',
    'FullName',
    'ReaderFor',
    'InitiatorFor'
  ];
  members;
  membersDisplay: any;
  dataSource: any;
  members$ = this.i1FilenetServices
    .getMembers(environment.usersGroup)
    .pipe(
      map(v =>
        v.sort((a, b) =>
          a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
        )
      )
    );

  constructor(private cdr: ChangeDetectorRef,
    private i1FilenetServices: I1FilenetServices,
    private dialog: MatDialog,
    private folderService: FolderService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    console.log("Manage User Access")
    this.showLoadingPopup = true;
    this.subs.add(
      this.members$.subscribe(v => {
        this.members = v.filter(member => {
          return !member.memberships.find(group => group.groupName.includes('CN=ACL Super Users'));
        })
        this.displayChange()
      })
    );

    this.subs.add(
      this.rootFolder$.subscribe(
        v => {
          this.libraryIDs = v.subFolders
          this.showLoadingPopup = false;
        }
      )
    )
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
}

  displayChange() {
    if (this.members && !this.membersDisplay) {
      this.membersDisplay = this.members;
    }
    if (this.membersDisplay) {
      this.dataSource = new MatTableDataSource<any>(this.membersDisplay);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.cdr.detectChanges();
    }

  }

  openReader(user: string) {
    console.log("Opening Reader Library Access");
    let dialogRef = this.dialog.open(AccessTypePopupComponent, {
      data: {
        title: 'Please Select Access for type READER',
        description: 'Please Select',
        option1: 'Yes',
        option2: 'No',
        objectStore: this.objectStoreRef
      },
      width: '100%'

    });


    let instance = dialogRef.componentInstance
    instance.accessType = 'READER';
    instance.user = user;
    instance.libraryIDs = this.libraryIDs

  }


  openInitiator(user: string) {
    console.log("Opening Intiator Library Access");
    let dialogRef = this.dialog.open(AccessTypePopupComponent, {
      data: {
        title: 'Please Select Access for type INITIATOR',
        description: 'Please Select',
        option1: 'Yes',
        option2: 'No',
        objectStore: this.objectStoreRef
      },
      width: '100%'

    });

    let instance = dialogRef.componentInstance
    instance.accessType = 'INITIATOR';
    instance.user = user;
    instance.libraryIDs = this.libraryIDs
  }





}
